import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import "./hm-theme.css";

const AddInvoicesByLab = ({ isOpen, onRequestClose, labId }) => {
  const navigate = useNavigate();

  const date = new Date();
  date.setDate(date.getDate());
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;

  const [labDetails, setLabDetails] = useState(false);
  const [taxes, setTaxes] = useState([]);
  const [loading, setLoading] = useState(false);

  const url = "/api/invoices/create";
  const [invoices, setInvoices] = useState({
    date: currentDate,
    startdate: "",
    enddate: "",
    labId: labId,
    grossamount: "",
    tax: "",
    netpay: "",
    invoicenumber: "",
    file: null,
    fileContentType: "",
    fileSize: "",
    createdBy: "",
    invoicesFor: "Admin",
    createdAdminId: "",
    invoiceFile: {
      file: null,
      fileContentType: "",
      fileSize: "",
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const taxRes = await axios.get("/api/tax", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTaxes(taxRes.data);

        const labRes = await axios.get(`/api/labdetails/${labId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLabDetails(labRes.data);
      } catch (error) {
        handleError(error);
      }
    };
    fetchData();
  }, []);

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data?.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else {
      toast.error(error.message || "An error occurred.");
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    const userRole = JSON.parse(localStorage.getItem("data")).role;

    let createdBy = "";
    if (userRole === "ROLE_LAB" || userRole === "ROLE_LAB_CORPORATE") {
      createdBy = "Lab";
    }

    if (
      invoices.date &&
      invoices.startdate &&
      invoices.enddate &&
      invoices.grossamount &&
      invoices.netpay &&
      invoices.invoicenumber
    ) {
      axios
        .post(
          url,
          {
            date: invoices.date,
            startdate: invoices.startdate,
            enddate: invoices.enddate,
            labId: labId,
            grossamount: invoices.grossamount,
            tax: invoices.tax,
            netpay: invoices.netpay,
            invoicenumber: invoices.invoicenumber,
            createdBy: createdBy,
            invoicesFor: invoices.invoicesFor,
            invoiceFile: invoices.invoiceFile,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(() => {
          setLoading(false);
          onRequestClose();
          setInvoices("");
          toast.success("Invoice Added Successfully");
        })
        .catch((error) => {
          handleError(error);
          setLoading(false);
        });
    } else {
      setLoading(false);
      toast.error("Please fill out all the required fields.");
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setInvoices((prevState) => ({ ...prevState, [id]: value }));
    if (id === "grossamount" || id === "tax") {
      calculateNetPay({ ...invoices, [id]: value });
    }
  };

  const calculateNetPay = ({ grossamount, tax }) => {
    const grossAmountValue = parseFloat(grossamount) || 0;
    const taxValue = parseFloat(tax) || 0;
    const netPay = grossAmountValue + (grossAmountValue * taxValue) / 100;
    setInvoices((prevState) => ({ ...prevState, netpay: netPay.toFixed(2) }));
  };

  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        const [metadata, content] = reader.result.split(",");
        resolve({ metadata, content });
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  const handlePdfFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const convertedPdf = await getBase64FromFile(file);
    setInvoices((prevState) => ({
      ...prevState,
      invoiceFile: {
        file: convertedPdf.content,
        fileSize: file.size,
        fileContentType: convertedPdf.metadata,
      },
    }));
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">receipt</i>
          Add Outgoing Invoice
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            {/* Invoice Number */}
            <div className="col-md-6">
              <label htmlFor="invoicenumber" className="form-label small fw-semibold">
                Invoice Number <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="invoicenumber"
                type="text"
                placeholder="e.g. INV-2026-001"
                value={invoices.invoicenumber}
                onChange={handleChange}
                required
              />
            </div>

            {/* Date */}
            <div className="col-md-6">
              <label htmlFor="date" className="form-label small fw-semibold">
                Date <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="date"
                type="date"
                value={invoices.date}
                onChange={handleChange}
                required
              />
            </div>

            {/* Start Date */}
            <div className="col-md-6">
              <label htmlFor="startdate" className="form-label small fw-semibold">
                Start Date <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="startdate"
                type="date"
                value={invoices.startdate}
                onChange={handleChange}
                required
              />
            </div>

            {/* End Date */}
            <div className="col-md-6">
              <label htmlFor="enddate" className="form-label small fw-semibold">
                End Date <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="enddate"
                type="date"
                value={invoices.enddate}
                onChange={handleChange}
                required
              />
            </div>

            {/* Gross Amount */}
            <div className="col-md-6">
              <label htmlFor="grossamount" className="form-label small fw-semibold">
                Gross Amount (₹) <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="grossamount"
                type="number"
                step="0.01"
                placeholder="0.00"
                value={invoices.grossamount}
                onChange={handleChange}
                required
              />
            </div>

            {/* Tax */}
            <div className="col-md-6">
              <label htmlFor="tax" className="form-label small fw-semibold">
                Tax (%) <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="tax"
                value={invoices.tax}
                onChange={handleChange}
                required
              >
                <option value="">Select Tax</option>
                {taxes.map((t) => (
                  <option key={t.id} value={t.tax}>
                    {t.tax}%
                  </option>
                ))}
              </select>
            </div>

            {/* Net Pay (read-only) */}
            <div className="col-md-6">
              <label htmlFor="netpay" className="form-label small fw-semibold">
                Net Pay (₹)
              </label>
              <input
                className="form-control bg-light"
                id="netpay"
                type="text"
                placeholder="Calculated automatically"
                value={invoices.netpay}
                readOnly
              />
            </div>

            {/* Upload File */}
            <div className="col-md-12">
              <label htmlFor="file" className="form-label small fw-semibold">
                Upload Invoice File (PDF / Image)
              </label>
              <input
                className="form-control"
                id="file"
                type="file"
                accept=".pdf,.png,.jpg,.jpeg"
                onChange={handlePdfFileChange}
              />
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-2 pt-3 border-top mt-4">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-pill px-4"
              onClick={onRequestClose}
            >
              Close
            </button>
            <button type="submit" className="btn btn-hm-primary px-4" disabled={loading}>
              {loading ? "Submitting..." : "Add Invoice"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddInvoicesByLab;
